/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box";
import {useCallback, useEffect, useState} from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";

import {useApiCallback} from "../util/Api";
import {useToastStore} from "../Toast";
import {useLoginStore} from "../useLoginStore";
import TotpInput from "../part/TotpInput";
import {Warning, Success} from "../part/Msg";


export default function MFA() {
    const [loading, setLoading] = useState(false)
    const [enrollCode, setEnrollCode] = useState(null)
    const [code, setCode] = useState('')
    const showSuccess = useToastStore(state => state.showSuccess);
    const id = useLoginStore(state => state.id);
    const [userinfo, setUserinfo] = useState({})

    const getUserinfo = useApiCallback('GET', `/api/person/${id}`, {setLoading, onDone: setUserinfo})
    useEffect(getUserinfo, [getUserinfo]);

    const enrollComplete = useCallback(msg => {
        setEnrollCode('')
        setCode('')
        showSuccess(msg)
        getUserinfo()
    }, [getUserinfo, showSuccess])

    const totpEnroll = useApiCallback('POST', '/api/totp_enroll', {setLoading, onDone: setEnrollCode})
    const totpVerify = useApiCallback('POST', '/api/totp_verify', {setLoading, onDone: enrollComplete})

    window.addEventListener('message', (event) => {
        if (event.origin === 'https://1password.com' && event.data.action === 'totpResponse') {
            setCode(event.data.totpCode)
        }
    });

    return <Container><Stack sx={{fontSize: {xs: '0.8em', sm: '0.9em', md: '1em'}}}>
        <Box container>
            <Button color="warning" onClick={() => totpEnroll()}>Enroll new MFA device</Button>
            {enrollCode
                ? <Stack direction="column" my={2} spacing={2} alignContent="center">

                    <Stack direction="row" spacing={2} alignContent="center">
                        <img alt="qr code to scan with your mobile device" src={enrollCode.img}
                             style={{maxWidth: 400}}/>
                    </Stack>

                    <TextField
                        type="text"
                        value={enrollCode.setupurl}
                    />

                    <Typography variant="h5" mt={3}>
                        Scan the QR code with your authenticator app and enter the code shown below:
                    </Typography>

                    <Stack direction="row" spacing={2} alignContent="center">
                        <TotpInput
                            disabled={loading}
                            value={code}
                            setValue={setCode}
                        />
                        <Button onClick={() => totpVerify({totp: code})}>Verify</Button>
                    </Stack>
                </Stack>
                : <Box m={2}>
                    {userinfo?.mfa_devices?.length
                        ? <Success>Your account is protected with MFA.</Success>
                        : <Warning>Your account is not protected with MFA.</Warning>
                    }
                </Box>
            }
        </Box>
    </Stack></Container>
}
